<template>
  <CFooter>
    <div>
      <a href="https://granite-scheduling.com/" target="_blank">Granite</a>
      <span class="ms-1">&copy; {{ new Date().getFullYear() }}</span>
    </div>
    <div class="ms-auto">
      <span class="me-1" target="_blank">
        Made with <CIcon icon="cilHeart" size="xl"
      /></span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
